import React, { useEffect } from "react";
import { Box } from "@mui/material";
import SavingsMain from "./main";
import SavingsOptions from "./savingsOptions";
import SavingsCalculator from "./savingsCalculator";
import FAQ from "../home/faq";
import CTA from "../home/cta";
import Footer from "../../components/footer";

const IndexSavings = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div style={{ overflowX: "clip" }}>
			<SavingsMain />
			<SavingsOptions />
			<Box
				sx={{
					position: "relative",
					width: "100vw",
					marginLeft: "calc(50% - 50vw)",
					background:
						"linear-gradient(to bottom, #FFFFFF 0%, #F6F4EE 25%, #F6F4EE 80%, #FFFFFF 100%)",
				}}
			>
				<Box
					sx={{
						"@media (min-width: 1700px)": {
							maxWidth: "70vw",
							margin: "auto",
						},
						"@media (min-width: 1600px) and (max-width: 1800px)": {
							maxWidth: "90vw",
							margin: "auto",
						},
					}}
				>
					<SavingsCalculator />
					<FAQ background="transparent" />
				</Box>
			</Box>
			<CTA />
			<Footer />
		</div>
	);
};

export default IndexSavings;
